const MAX_ARCHIVE_PARTS_PER_ADD = 500;

/**
 * Parse archive message ID input.
 * "120"     → [120]
 * "120:5"   → [120, 121, 122, 123, 124]
 */
export function parseArchiveIdInput(raw) {
  const trimmed = String(raw ?? "").trim();
  if (!trimmed) {
    return { error: null, ids: [] };
  }

  const rangeMatch = trimmed.match(/^(\d+)\s*:\s*(\d+)$/);
  if (rangeMatch) {
    const startId = Number(rangeMatch[1]);
    const count = Number(rangeMatch[2]);

    if (!Number.isInteger(startId) || startId <= 0) {
      return { error: "Invalid message ID", ids: [] };
    }
    if (!Number.isInteger(count) || count <= 0) {
      return { error: "Count must be a positive number", ids: [] };
    }
    if (count > MAX_ARCHIVE_PARTS_PER_ADD) {
      return {
        error: `Maximum ${MAX_ARCHIVE_PARTS_PER_ADD} parts at once`,
        ids: [],
      };
    }

    const ids = Array.from({ length: count }, (_, i) => startId + i);
    return { error: null, ids };
  }

  if (!/^\d+$/.test(trimmed)) {
    return {
      error: "Use a message ID or start:count (e.g. 120:5)",
      ids: [],
    };
  }

  const id = Number(trimmed);
  if (!Number.isInteger(id) || id <= 0) {
    return { error: "Invalid message ID", ids: [] };
  }

  return { error: null, ids: [id] };
}

export function resolveNewArchiveIds(raw, existingIds) {
  const { error, ids } = parseArchiveIdInput(raw);
  if (error || ids.length === 0) {
    return { error, ids: [] };
  }

  const existing = new Set(existingIds);
  const unique = ids.filter((id) => !existing.has(id));
  if (unique.length === 0) {
    return { error: "This message ID is already added", ids: [] };
  }

  return { error: null, ids: unique };
}
